module.exports = __webpack_public_path__ + "img/ch72.53d6d3f9.jpg";